<template>
  <div class="filter-box">
    <div class="filter-box-header">
      <div class="filter-box-title">
        <div class="filter-box-icon" />
        <div class="filter-box-text">{{ meta.label }}</div>
      </div>
      <!-- <div
        v-if="dimension.role==='filters'"
        class="eye"
        :class="{active: dimension.quick_filter}"
        @click="toggleQuickFilter"
      /> -->
      <div v-if="dimension.role!=='filters'" class="remove" @click="$emit('remove',dimension.id)" />
    </div>
    <!-- {{ internalTypeValue }} -->
    <!-- {{ internalTypeValue }}
    <br>
    <br>
    {{ typeOptions }} -->
    <div class="sub-select">
      <div class="sub-select-title">{{ $t('type') }}</div>
      
      <!-- :multiple="dimension.role!=='filters' && meta.type==='location' && chartType !== 'pie-chart'" -->
      <select-comp-wrapper
        v-model="internalTypeValue"
        :options="typeOptions"
        
        :multiple="multipleTypes"
        :unsortable="meta.type==='time' || meta.type==='location'"
      />
    </div>
    <!-- {{ nestedOptions }} -->
    <!-- {{ internalValue }} -->
    <!-- {{ internalValue }} -->
    <!-- <br>
    <br>
    {{ nestedOptions }} -->
    <!-- <template v-for="t in internalTypeValue">
      {{ t }}<br><br>
      {{ internalValue[t.value] }}<br> <br>
      {{ nestedOptions[t.value] }}
    </template> -->
    <div
      v-for="t in internalTypeValue"
      :key="t.value"
      class="sub-select"
    >
      <div class="sub-select-title">{{ t.labelType }}</div>
      <select-comp-wrapper
        :time-children="meta.type === 'time'"
        :value="internalValue[t.value]"
        :options="nestedOptions[t.value]"
        :multiple="dimension.role!=='filters'"
        :can-bold="dimension.role==='rows'"
        :can-chart="dimension.role=='columns'"
        :unsortable="meta.type==='time' || meta.type==='location'"
        @change="(newVal)=>onValueChange(internalValue[t.value],newVal,t.value)"
      />
    </div>
  </div>
</template>

<script>
import SelectCompWrapper from './SelectCompWrapper.vue'
export default {
  components: {
    SelectCompWrapper,
  },
  // SE HACE "a mano" porque v-model no funciona dentro de un "for"
  // model: {
  //   prop: 'dimension',
  //   event: 'change',
  // },
  props: {
    dimension: Object,
    typeDimension: Object,
    options: Array,
    typeOptions: Array,
    meta: Object,
    // chartType: String,
    multipleTypes: Boolean,
  },
  computed: {
    // LO QUITO DE MOMENTO: Cuando encontremos una tabla con algun type "vacio" lo ponemos
    // parsedTypeOptions() {
    //   this.typeOptions.forEach((el, i) => {
    //     let tmp = this.options.find(elem => el.id === elem.type)
    //     if (tmp?.count && tmp.count === 0) {
    //       this.typeOptions.splice(i, 1)
    //     }
    //   })
    //   return this.typeOptions
    // },
    nestedOptions() {
      let result = this.typeOptions.reduce((dict, t) => {
        dict[t.id] = this.options.filter(o => {
          return o.type === t.id
        })
        return dict
      }, {})
      return result
    },
    internalTypeValue: {
      get() {
        // this.typeDimension.values.forEach((el, i) => {
        //   let tmp = this.options.find(elem => el.type === elem.type)
        //   if (tmp?.count && tmp.count === 0) {
        //     this.typeDimension.values.splice(i, 1)
        //   }
        // })
        // return this.typeDimension.values
        return this.typeDimension.values
      },
      set(value) {
        value.forEach(
          e =>
            (e['labelType'] = this.meta.typeOptions.find(el => el.type === e.type)?.label || e.type)
        )
        let newDimension = { ...this.typeDimension, values: value }
        this.$emit('changeType', newDimension)
      },
    },
    // BASTANTE OBSCURO... porque el get devuelve "Object by type" pero el set espera "Array plano"
    internalValue: {
      get() {
        // let self = this
        // return this.dimension.values

        // ESTA "MAL" cuando movemos "location" a filters, esto "pone" districte: [] y hace que "pete" pero
        // no tendria que ponerse aqui ningun default creo...

        // let tmp = this.typeOptions.reduce((dict, t) => {
        //   let partialDim = self.dimension.values.filter(d => d.type === t.id)
        //   if (partialDim.length !== 0) {
        //     let dimOptions = self.options.filter(op => op.type === partialDim[0].type)
        //     dimOptions.forEach(o => {
        //       if (o.count && o.count === 0) {
        //         partialDim.splice(
        //           partialDim.findIndex(x => x.value === o.id),
        //           1
        //         )
        //       }
        //     })
        //     dict[t.id] = partialDim
        //   }
        //   return dict
        // }, {})
        // return tmp
        let tmp = this.typeOptions.reduce((dict, t) => {
          dict[t.id] = this.dimension.values.filter(d => d.type === t.id)
          return dict
        }, {})
        return tmp
      },
      set(value) {
        // this.dimension.values = value
        let newDimension = { ...this.dimension, values: value }
        this.$emit('change', newDimension)
      },
    },
  },
  methods: {
    toggleQuickFilter() {
      this.dimension.quick_filter = !this.dimension.quick_filter
      this.$emit('change', this.dimension)
    },
    // filter(flatValues) {
    //   let root = this.options.find(o => o.type === this.typeOptions[0].id)
    //   let dive = node => {
    //     if (node.values) {
    //       let nestedChildren = node.values
    //         .filter(c => flatValues.findIndex(cc => cc.value === c.id) >= 0)
    //         .map(child => dive(child))
    //       return { id: node.id, children: nestedChildren }
    //     } else {
    //       return { id: node.id }
    //     }
    //   }
    //   let tree = dive(root, {})
    //   let flatten = (node, arr) => {
    //     arr ||= []
    //     arr.push(node)
    //     if (node.children) {
    //       node.children.forEach(child => flatten(child, arr))
    //     }
    //     return arr.flat(Infinity)
    //   }
    //   return flatten(tree) // rowDimensionValues
    // },
    onValueChange(val, newVal, type) {
      // if (!val) val = []
      let flatValues = Object.keys(this.internalValue)
        .map(key => {
          if (key === type) return newVal
          else return this.internalValue[key]
        })
        .flat()
      // Para quitar los hijos, o meterlos en la seleccion automaticamente
      // Solo baja un piso... si encontramos datos con mas pisos lo inento... :D
      let removed = val.filter(x => newVal.findIndex(xx => xx.value === x.value) < 0)
      let added = newVal.filter(x => val.findIndex(xx => xx.value === x.value) < 0)

      if (removed.length) {
        // console.log('removed', removed)
        removed.forEach(removedItem => {
          let parent = this.options.find(o => o.id === removedItem.value)
          if (parent.values)
            flatValues = flatValues.filter(fv => {
              return parent.values.findIndex(c => c.id === fv.value) < 0
            })
        })
      }
      if (added.length) {
        // console.log('added', added)
        added.forEach(addedItem => {
          let parent = this.options.find(o => o.id === addedItem.value)
          if (parent.values) {
            let newChildren = parent.values.filter(d => !flatValues.find(dd => dd.value === d.id))
            newChildren = newChildren.map(d => ({ value: d.id, type: d.type }))
            flatValues = flatValues.concat(newChildren)
          }
        })
      }
      this.internalValue = flatValues
    },
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="stylus" scoped>
.filter-box
  padding: vw(10px)
  background-color: $bcn-grey

.filter-box-header
  display: flex
  justify-content: space-between
  align-content: center
  margin-bottom: vw(10px)

.filter-box-title
  display: flex
  align-items: center
  gap: vw(2px)

.filter-box-icon
  m-icon("drag", 20)

.filter-box-text
  // m-first-letter-case()
  m-font-size(14, 20)
  font-weight: 600

.sub-select
  &:not(:last-child)
    margin-bottom: vw(10px)

.sub-select-title
  // m-first-letter-case()
  m-font-size(12, 16)
  margin-bottom: vw(5px)

.eye
  m-icon("eye", 20)

  &.active
    m-icon("eye-bold", 20)

.remove
  m-icon("close", 20)
  cursor: pointer
</style>
